import { Base } from "@/atoms-react/text/Text.react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Button } from "@/atoms-react/button/Button.react";
import { Themes } from "@/types/theme";

export const OlkywalletCard = () => {
  const { t } = useTranslation(["pass"]);

  const olkyCardsClassName =
    "w-full h-[188px] lg:h-[188px] xl::h-[223px] 2xl:h-[223px] p-4 md:py-6 flex ";
  const baseTextClassName = "text-white font-semibold mt-0 z-10";

  const redirectToWalletDashboard = () => {
    /* navigate(getRoute(Routes.wallet_dashboard), {
      replace: true
    })*/
  };
  return (
    <>
      <div
        className={twMerge(
          'relative w-full overflow-hidden rounded-sm bg-[url("/images/olkypass/bg_olky_wallet.jpg")] bg-center bg-cover opacity-1'
        )}
        onClick={redirectToWalletDashboard}
      >
        <div className={`${olkyCardsClassName} items-left flex-col justify-start`}>
          <Base className={twMerge(baseTextClassName, "text-left")}>
            {t("olkypass.general.olky_wallet")}
          </Base>
          <div className="mt-auto flex flex-1 items-end">
            <Button
              size="md"
              theme={Themes.white}
              disabled
              onClick={redirectToWalletDashboard}
              className="mt-4 h-8 w-48 w-68 border-none bg-white text-black text-orange-500 text-xs sm:h-10 sm:text-base lg:h-8 lg:text-sm xl:h-10 xl:text-base xl:text-lg dark:bg-white dark:text-black"
            >
              {t("olkypass.mainPage.olkypass.bloc3.btn")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
